import React from 'react';
import {Alert} from 'react-bootstrap';
import isEmpty = require("lodash/isEmpty");
import styled from "styled-components";
import {IDomainObject} from "core/form/formUtils";
import {observer} from "mobx-react";
import {action} from "mobx";

interface AlertCompProps {
  children: any;
  onDismiss?: Function;
  header?: any;
  level: string;
}

const StyledAlert = styled(Alert)`
      margin-top: 10px;
      box-sizing: content-box;
      button {
        float: right;
        border: 0;
        background-color: rgba(0,0,0,0);
      }
`;


export const AlertComp = ({level, children, onDismiss, header}: AlertCompProps) => (
  (children) ? <StyledAlert bsStyle={level} onDismiss={onDismiss}>
    {(header) ? <h4>{header}</h4> : null}
    {children}
  </StyledAlert> : <noscript/>
);



interface EmailSentCompProps {
  objekt: IDomainObject;
  header?: any;
  level: string;
}

@observer
export class EmailSentComp extends React.Component<EmailSentCompProps, undefined> {

  @action onDismiss = () => {
    const objekt = this.props.objekt;
    if (objekt.tupleMap) {
      objekt.tupleMap.emailedPersons = undefined;
      objekt.tupleMap.excludedPersons = undefined;
    }
  };

  render() {
    const {objekt, header, level} = this.props;
    return (
      (objekt.tupleMap && !isEmpty(objekt.tupleMap.emailedPersons)) ? <StyledAlert bsStyle={level} onDismiss={this.onDismiss}>
        {(header) ? <h4>{header}</h4> : null}
        <div>
          Email sent to
          <ul>
            {Object.entries(objekt.tupleMap.emailedPersons).map( ([k,v]:[string, string[]], index) => <li key={index}>  {k + " (" + v.join(", ") + ")"}</li>)}
          </ul>
        </div>
        {(!isEmpty(objekt.tupleMap.excludedPersons)) ? (
          <div>
            Excluded
            <ul>
              {Object.entries(objekt.tupleMap.excludedPersons).map( ([k,v]:[string, string[]], index) => <li key={index}>  {k + " (" + v.join(", ") + ")"}</li>)}
            </ul>
          </div>
        ) : null}
      </StyledAlert> : <noscript/>
    )
  };
}



// WEBPACK FOOTER //
// ./src/core/components/errorComp/alertComp.tsx